import LinearProgress from "@mui/material/LinearProgress";
import Box from "@mui/material/Box";

export const LoadingModal = () => {
  return (
    <Box
      sx={{
        width: "100%",
        position: "absolute",
        top: "0%",
        left: "50%",
        transform: "translate(-50%, -50%)",
      }}
    >
      <LinearProgress />
    </Box>
  );
};
